var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00144 7.83364C8.83752 7.83364 10.4599 8.26707 11.7779 8.83373C12.9947 9.36699 13.7607 10.5667 13.7607 11.867V13.6668H0.242188V11.8782C0.242188 10.5667 1.0086 9.36699 2.225 8.84486C3.54299 8.26707 5.16536 7.83364 7.00144 7.83364ZM7.00144 0.3335C7.44544 0.332865 7.88519 0.418643 8.29552 0.58592C8.70584 0.753197 9.07867 0.998684 9.39264 1.30832C9.70661 1.61795 9.95554 1.98564 10.1252 2.39033C10.2948 2.79501 10.3819 3.22874 10.3813 3.66665C10.3819 4.10459 10.2949 4.53835 10.1253 4.94308C9.95568 5.34781 9.70675 5.71554 9.39277 6.02522C9.0788 6.33489 8.70596 6.58041 8.29561 6.74771C7.88526 6.91501 7.44547 7.0008 7.00144 7.00016C6.55745 7.00075 6.1177 6.91492 5.7074 6.7476C5.29709 6.58028 4.92429 6.33475 4.61036 6.02508C4.29643 5.71542 4.04753 5.3477 3.87793 4.94299C3.70833 4.53829 3.62136 4.10456 3.622 3.66665C3.62141 3.22877 3.70842 2.79507 3.87804 2.39041C4.04766 1.98575 4.29657 1.61808 4.61049 1.30845C4.92442 0.998821 5.2972 0.753325 5.70748 0.586026C6.11777 0.418727 6.55748 0.332913 7.00144 0.3335Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersProfiles);
export default __webpack_public_path__ + "static/media/users_profiles.e79cdc0263eb34147cf36c1c0807a5e1.svg";
export { ForwardRef as ReactComponent };